import { z } from "zod";
import { AuthUserSchema, AuthClientSchema, AuthOrganizationSchema } from "../auth-v2/common";

// ==================
// Validate Invite Response
// ==================

/**
 * Response from GET /api/v2/auth/invites/validate/{token}
 * Contains the invitation details if the token is valid
 */
export const ValidateInviteResponseSchema = z.object({
  email: z.string().email(),
  first_name: z.string(),
  last_name: z.string(),
  expires_at: z.string(),
});

export type ValidateInviteResponse = z.infer<typeof ValidateInviteResponseSchema>;

// ==================
// Accept Invite Request
// ==================

/**
 * Request body for POST /api/v2/auth/invites/accept
 */
export const AcceptInviteRequestSchema = z.object({
  token: z.string().min(1),
  password: z.string().min(8),
  password_confirmation: z.string().min(8),
});

export type AcceptInviteRequest = z.infer<typeof AcceptInviteRequestSchema>;

// ==================
// Accept Invite Response
// ==================

/**
 * Client info returned in accept invite response
 */
export const AcceptInviteClientSchema = z.object({
  id: z.number(),
  company_name: z.string(),
});

export type AcceptInviteClient = z.infer<typeof AcceptInviteClientSchema>;

/**
 * Organization info returned in accept invite response
 */
export const AcceptInviteOrganizationSchema = z.object({
  id: z.number(),
  name: z.string(),
});

export type AcceptInviteOrganization = z.infer<typeof AcceptInviteOrganizationSchema>;

/**
 * Response from POST /api/v2/auth/invites/accept
 * Returns user info, auth token, and associated client/organization
 */
export const AcceptInviteResponseSchema = z.object({
  user: AuthUserSchema,
  type: z.literal("client"),
  token: z.string(),
  client: AcceptInviteClientSchema.optional(),
  organization: AcceptInviteOrganizationSchema.optional(),
});

export type AcceptInviteResponse = z.infer<typeof AcceptInviteResponseSchema>;
